<div class="filters">
  <div class="filter">
    <label for="customerId">Kunde</label>
    <p-multiSelect
      [options]="customerOptions"
      [(ngModel)]="selectedCustomerIds"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      display="chip"
      placeholder="Alle"
      scrollHeight="250px"
      (keydown.enter)="filterGroups()"
      (ngModelChange)="onAnyChange()"
      [style]="{ width: '240px', maxWidth: '240px' }"
    ></p-multiSelect>
  </div>
  <div class="filter">
    <label for="name">Gruppenname</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        id="name"
        pInputText
        placeholder="Suchen"
        type="text"
        [(ngModel)]="name"
        (keydown.enter)="filterGroups()"
        (ngModelChange)="onAnyChange()"
      />
    </p-iconField>
  </div>
  <div class="filter">
    <label for="orderTitle">Auftragsnummer</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        id="orderTitle"
        pInputText
        placeholder="Suchen"
        type="text"
        [(ngModel)]="orderTitle"
        (keydown.enter)="filterGroups()"
        (ngModelChange)="onAnyChange()"
      />
    </p-iconField>
  </div>
  <div class="filter">
    <label for="userQuery">Kundennutzer</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        id="userQuery"
        pInputText
        placeholder="E-Mail, Vorname oder Nachname"
        type="text"
        [(ngModel)]="userQuery"
        (keydown.enter)="filterGroups()"
        (ngModelChange)="onAnyChange()"
      />
    </p-iconField>
  </div>

  <div class="filter-actions">
    <app-button (click)="filterGroups()" label="Filtern" type="primary-button" />
    <app-button
      (click)="clearFilter()"
      label="Filter zurücksetzen"
      type="secondary-button"
      [disabled]="!showClearButton"
    />
  </div>
</div>
